import { ROUTE } from '@utils/route-utils';

/**
 * What a Free organization sees on a route: `classics` (the classic cocktail
 * library, with the upgrade card), `open` (plan and account pages, as is) or
 * `locked` (the upgrade card alone).
 */
export type FreePlanRouteAccess = 'classics' | 'open' | 'locked';

const FREE_PLAN_OPEN_ROUTES: ReadonlySet<string> = new Set([
  ROUTE.UPGRADE,
  ROUTE.SETTINGS,
  ROUTE.LEGAL,
  ROUTE.WELCOME
]);

export function freePlanRouteAccess(
  pathname: string,
  organization_id: string
): FreePlanRouteAccess {
  const prefix = `/${organization_id}`;
  if (pathname !== prefix && !pathname.startsWith(`${prefix}/`)) {
    return 'locked';
  }
  const segments = pathname.slice(prefix.length).split('/').filter(Boolean);
  const [first, second, recipeId, ...rest] = segments;
  if (!first || (first === ROUTE.HOME && segments.length === 1)) {
    return 'classics';
  }
  if (FREE_PLAN_OPEN_ROUTES.has(first)) {
    return 'open';
  }
  if (
    first === ROUTE.BEVERAGES &&
    second === ROUTE.RECIPES &&
    recipeId !== 'create' &&
    rest.length === 0
  ) {
    return 'classics';
  }
  return 'locked';
}
